import React from 'react';
import moment from 'moment';

import { DateSelectorInput } from '../../components/input';
import LeadChoiceChips from './LeadChoiceChips';

export const FOLLOW_UP_DATE_FORMAT = 'YYYY-MM-DD';

export const getFollowUpDate = days => moment().startOf('day').add(days, 'days').format(FOLLOW_UP_DATE_FORMAT);

// Same quick choices and earliest date as the Sentry Clients phone screens.
const QUICK_OPTIONS = [
	{ label: 'Tomorrow', days: 1 },
	{ label: '1 week', days: 7 },
	{ label: '2 weeks', days: 14 },
	{ label: '1 month', days: 30 },
];

const LeadFollowUpDateInput = ({ value, onChange, disabled = false }) => {
	const options = QUICK_OPTIONS.map(option => ({ label: option.label, value: getFollowUpDate(option.days) }));

	return (
		<>
			<LeadChoiceChips
				options={options}
				selectedValue={value}
				onSelect={onChange}
				disabled={disabled}
			/>
			<DateSelectorInput
				value={value}
				onChange={onChange}
				disabled={disabled}
				placeholder="Select date"
				clearLabel="Clear date"
				minimumDate={moment().startOf('day').toDate()}
			/>
		</>
	);
};

export default LeadFollowUpDateInput;
